import { createRouter, createWebHistory } from 'vue-router'

// Har bir sahifa uchun komponentlarni import qilamiz
import HomeView from '@/views/HomeView.vue';
import AboutViewVue from '@/views/AboutView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'About',
    component: AboutViewVue
  },
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 🚀 Har bir sahifaga o'tganda to'liq qayta yuklash
router.beforeEach((to, from, next) => {
  if (to.fullPath !== window.location.pathname) {
    window.location.href = to.fullPath // sahifani to'liq yangilaydi
  } else {
    next() // agar allaqachon shu sahifada bo‘lsa, o‘tkaz
  }
})

export default router
